import React, { useState, useRef } from "react";
import Tabs from "../../../Tabs";
import { WheelCategories } from "../../../WheelGallery/WheelListing/TabComponents/WheelsTab";
import MagicWand from "../../../../assets/icons/MagicWand";
import { CloneV2 } from "../../../../assets/icons";
import IyugaTooltip from "../../../IyugaTooltip";
import InfoIcon from "assets/images/segmentLibrary/info.svg";
import TextView from "../../../TextView";

export const SegmentLibraryTabs = ({
  numberOfCreatedWheels,
  numberOfClonedWheels,
  selectedWheelCategory,
  setSelectedWheelCategory,
}) => {
  const scrollPositionsRef = useRef({
    Created: 0,
    Cloned: 0,
    // Unlocked: 0,
    // Favourited: 0,
  });

  const handleTabChange = (event, newTab) => {
    const scrollableContainer = document.getElementById("MainScrollableView");
    if (scrollableContainer) {
      scrollPositionsRef.current[selectedWheelCategory] =
        scrollableContainer.scrollTop;
    }
    setSelectedWheelCategory(newTab);
  };

  return (
    <Tabs
      variant="standard"
      sx={{}}
      categoriesWithIcons={[
        {
          label: "Created",
          value: WheelCategories.Created,
          icon: <MagicWand />,
          suffix: numberOfCreatedWheels,
        },
        {
          label: "Cloned",
          value: WheelCategories.Cloned,
          icon: <CloneV2 />,
          suffix: numberOfClonedWheels,
          customIcon: (
            <IyugaTooltip
              tooltip={
                <div
                  style={{
                    whiteSpace: "pre-line",
                  }}
                >
                  <TextView variant="text" style={{ textAlign: "center" }}>
                    Only Static Clone Segments can be copied into Wheels via the
                    Segment Library.
                  </TextView>
                </div>
              }
              width={"180px"}
            >
              <img src={InfoIcon} alt="Info" width={24} height={24} />
            </IyugaTooltip>
          ),
        },
      ]}
      selectedCategory={selectedWheelCategory}
      onCategoryChange={handleTabChange}
    />
  );
};
